import React from "react";
import TotalEcoContent from "../components/TotalEcoContent";
import TitleFormat from "../components/TitleFormat";
import { useTranslation } from "react-i18next";
import { Seo } from "../components/Seo";

const TotalEco = () => {
  const { t } = useTranslation();
  return (
    <>
      <Seo title={t("consulting.totalEco.seo.title")} description={t("consulting.totalEco.seo.des")} path="eco-planning/eco-consulting" />
      <TitleFormat text={t("consulting.totalEco.title")} />
      <TotalEcoContent />
    </>
  );
};

export default TotalEco;
